import type { PlayerItem } from "../types";
import { getItemIconPath, RARITY_COLOR } from "../utils/assets";
import clsx from "clsx";
import { AdminAssetPath } from "./AdminAssetPath";
import { ModalBackdrop } from "./ModalBackdrop";

interface LootDropModalProps {
  item: PlayerItem;
  heroClass: import("../types").HeroClass;
  onDismiss: () => void;
}

export function LootDropModal({ item, heroClass, onDismiss }: LootDropModalProps) {
  const t = item.template;
  const iconSrc = getItemIconPath(t.hero_class ?? heroClass, t.slot, t.icon, t.item_level);
  const rarityClass = RARITY_COLOR[t.rarity] ?? RARITY_COLOR.JUNK;

  return (
    <ModalBackdrop onClose={onDismiss} className="z-[60] items-center bg-black/80 p-6">
      <div className="w-full max-w-xs bg-gradient-to-b from-kingdom-purple to-kingdom-dark border-2 border-gold-500/50 rounded-2xl p-6 text-center space-y-4 animate-bounce-in">
        <div className="text-4xl">🎁</div>
        <div className="text-lg font-bold font-game text-gold-300">Item Found!</div>
        <img
          src={iconSrc}
          alt={t.name}
          className={clsx(
            "w-20 h-20 mx-auto rounded-xl border-2 object-contain bg-kingdom-dark",
            rarityClass,
          )}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
        <AdminAssetPath path={iconSrc} className="text-center px-2" />
        <div>
          <div className="font-bold text-white">{t.name}</div>
          <div className={clsx("text-sm", rarityClass.split(" ")[0])}>
            {t.rarity} · Lv.{t.item_level}
          </div>
        </div>
        <button
          onClick={onDismiss}
          className="w-full py-3 bg-gradient-to-r from-gold-500 to-gold-600 text-black font-bold rounded-xl"
        >
          Nice!
        </button>
      </div>
    </ModalBackdrop>
  );
}
